import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=857b7daa&scoped=true&"
import script from "./CommonTab.vue?vue&type=script&lang=js&"
export * from "./CommonTab.vue?vue&type=script&lang=js&"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=857b7daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857b7daa",
  null
  
)

export default component.exports